import React from "react";
import { X } from "lucide-react";
import { StatusBadge } from "./ui-kit";

export function NutritionResultBadge({ needsValidation }) {
  return needsValidation
    ? <StatusBadge status="giallo">Necessita validazione tecnica</StatusBadge>
    : <StatusBadge status="verde">Nessuna validazione richiesta</StatusBadge>;
}

// "Motivazione tecnica" per la dichiarazione nutrizionale — stesso pattern
// di ShelfLifeWhyDrawer, per restare coerenti tra i due motori esperti.
export function NutritionWhyDrawer({ assessment, onClose }) {
  if (!assessment) return null;
  const { reasoning, result } = assessment;
  const per100 = result.per_100g_raw;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-navy/60 p-4 backdrop-blur-sm overflow-y-auto" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="relative mt-6 w-full max-w-2xl rounded-2xl border border-hairline bg-white p-6 shadow-2xl sm:p-8">
        <button type="button" onClick={onClose} className="absolute right-3 top-3 grid h-11 w-11 place-items-center rounded-full text-slate-500 hover:bg-slate-100" aria-label="Chiudi"><X className="h-5 w-5" /></button>
        <h2 className="pr-10 font-heading text-xl font-bold text-navy">Perché questi valori nutrizionali?</h2>
        <p className="mt-1 text-sm text-slate-500">{assessment.recipe_name_snapshot} — {per100 ? `${per100.kcal} kcal / 100 g` : "dichiarazione non calcolabile"}</p>

        <div className="mt-4 space-y-2">
          {(reasoning.reasons || []).map((r, i) => (
            <div key={i} className="rounded-lg bg-slate-50 px-3 py-2 text-sm text-navy">{r}</div>
          ))}
          {(reasoning.warnings || []).map((w, i) => (
            <div key={`w${i}`} className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">⚠ {w}</div>
          ))}
        </div>

        {result.quid?.length > 0 && (
          <div className="mt-5">
            <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">QUID</div>
            <ul className="space-y-1 text-sm text-navy">
              {result.quid.map((q, i) => <li key={i}><strong>{q.ingredient}</strong>: {q.quid_percent}%</li>)}
            </ul>
          </div>
        )}

        {reasoning.sources?.length > 0 && (
          <div className="mt-5">
            <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">Fonti dei valori utilizzati</div>
            <ul className="space-y-1 text-sm text-navy">
              {reasoning.sources.map((s, i) => <li key={i}><strong>{s.name}</strong>: {s.source} ({s.evidence_level})</li>)}
            </ul>
          </div>
        )}

        {assessment.regulatory_references_snapshot?.length > 0 && (
          <div className="mt-5">
            <div className="mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500">Riferimenti normativi</div>
            <ul className="space-y-1 text-sm text-navy">
              {assessment.regulatory_references_snapshot.map((r, i) => (
                <li key={i}><strong>{r.law}</strong>{r.article ? ` — ${r.article}` : ""}{r.note ? `: ${r.note}` : ""}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
